<template>
  <div class="header">
    <div class="user-tool">
      <div class="tpl-header">
        <!-- <div class="tpl-header-item">
          <div class="title" v-popover:notice>
            <i class="iconfont icon-tongzhi"></i>
            <span class="name">通知</span>
            <span class="num n1">3</span>
          </div>
          <el-popover ref="notice" placement="bottom" width="160">
            通知内容
          </el-popover>
        </div>
        <div class="tpl-header-item">
          <div class="title" v-popover:progress>
            <i class="iconfont icon-iconfont14052226"></i>
            <span class="name">项目进度</span>
            <span class="num n2">3</span>
          </div>
          <el-popover ref="progress" placement="bottom" width="160">
            通知内容
          </el-popover>
        </div> -->
      </div>
      <strong class="t4">欢迎您，{{userData.name}}</strong>
      <a href="javascript:;" @click="signOut()" class="signOut">退出</a>
    </div>
    <div class="logo"></div>
    <div class="nav">
      <ul>
        <li :class="mainType=='index' ? 'cur' : ''">
          <router-link to="/">首页</router-link>
        </li>
        <li :class="mainType=='contacts'?'cur':''">
          <router-link to="/Contacts">通讯录</router-link>
        </li>
        <li :class="mainType=='administrative'?'cur':''">
          <router-link to="/Meeting/List">行政/人事</router-link>
        </li>
        <li v-if="backNavRole('ST')" :class="mainType=='storage'?'cur':''">
          <router-link to="/Storage/MaterialUseList">材料仓库</router-link>
        </li>
        <li v-if="backNavRole('AS')" :class="(mainType=='asset')?'cur':''">
          <router-link to="/Asset/MyList">固定资产管理</router-link>
        </li>
        <li v-if="backNavRole('YH')" :class="mainType=='consumable'?'cur':''">
          <router-link to="/Consumable/ApplyList">易耗品管理</router-link>
        </li>
        <li v-if="userData.roles && isSystemAdmin()" :class="(mainType=='role'||mainType=='setting')?'cur':''">
          <router-link to="/Set/UserGroup">系统管理</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import Role from '@/Mixins/role'
  export default {
    mixins: [Role],
    data() {
      return {
        // msg: 'Welcome to Your Vue.js App'
      }
    },
    computed: {
      ...mapState({
        mainType: state => state.main.mainType,
        userData: state => state.main.userData
      })
    },
    mounted() {},
    methods: {
      signOut() {
        this.$store.commit('set_userData', '')
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/Header.vue